<template>
  <v-dialog v-model="show" :max-width="500" :fullscreen="$vuetify.breakpoint.xsOnly" transition="dialog-bottom-transition" scrollable>
    <v-card :class="{ 'rounded-xl': !$vuetify.breakpoint.xsOnly }" elevation="10" class="d-flex flex-column">
      <v-card-title class="pa-4 primary white--text d-flex justify-space-between align-center">
        <span class="text-h6 font-weight-bold">Activar usuario</span>
        <v-btn icon dark @click="closeModal" v-if="$vuetify.breakpoint.xsOnly">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-6 bg-app">
        <v-container>
          <v-form ref="activeUser">
            <v-row>
              <v-col cols="12" class="pb-0">
                <span class="text-subtitle-1 font-weight-bold primary--text">Nueva contraseña</span>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  label="Contraseña"
                  :rules="validationPassword()"
                  v-model="password"
                  prepend-inner-icon="mdi-form-textbox-password"
                  class="white rounded-lg"
                  append-icon="mdi-auto-fix"
                  @click:append="generatePassword"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4 bg-white">
        <v-spacer></v-spacer>
        <v-btn
          color="grey"
          text
          @click="closeModal"
          :disabled="isLoading"
          class="px-4"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          rounded
          @click="active"
          :loading="isLoading"
          elevation="0"
          class="px-8"
        >
          Activar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//Vuex
import { mapActions, mapState, mapMutations } from "vuex";
//validation
import { requiredValidationPassword } from "@/helpers/validations.js";
export default {
  data: () => ({
    isLoading: false,
    password: null,
  }),
  props: {
    value: Boolean,
  },
  computed: {
    ...mapState("user", ["userSelected"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapActions("user", ["activeUser"]),
    ...mapMutations("user", ["SET_USER_TO_UPDATE"]),
    closeModal() {
      this.SET_USER_TO_UPDATE(null);
      this.show = false;
    },
    validationPassword(name) {
      return requiredValidationPassword(name);
    },
    generatePassword() {
      const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      const passwordLength = 13;
      let password = "";

      for (let i = 0; i < passwordLength; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        password += characters.charAt(randomIndex);
      }
      this.password = password;
    },
    async active() {
      try {
        if (this.$refs.activeUser.validate()) {
          let payload = {
            userId: this.userSelected._id,
            password: this.password,
          };
          let response = await this.activeUser(payload);
          if (!response) throw response;
          this.$emit("fetchData");
          this.SET_USER_TO_UPDATE(null);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Usuario activado",
            timeout: 5000,
          });
          this.show = false;
        }
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al suspender usuario",
          timeout: 5000,
        });
      }
    },
  },
};
</script>
